"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputParser = void 0;
class InputParser {
    constructor(expressionParser) {
        // match `${{ xxxx }}`
        this.inputJSONPathRe = /\$\{\{([\w [\].]+)\}\}/g;
        this.expressionParser = expressionParser;
    }
    render(input, context) {
        return this.expressionParser.exec(input.value, context);
        // return Object.keys(input).reduce((acc, key) => {
        //   const value = input[key];
        //   if (typeof value !== 'object' || ![OperandTypeEnums.Literal, OperandTypeEnums.Expression].includes(value?.type)) {
        //     throw Error('Object Value Must Be A IOperand Object!');
        //   }
        //   switch (value.type) {
        //     case OperandTypeEnums.Literal:
        //       acc[key] = value.value;
        //       break;
        //     case OperandTypeEnums.Expression:
        //       acc[key] = this.expressionParser.exec(value.value, context);
        //       break;
        //     default:
        //       throw Error('Object Value Must Be A IOperand Object!');
        //   }
        //   return acc;
        // }, {});
    }
}
exports.InputParser = InputParser;
//# sourceMappingURL=input_parser.js.map